import React, { useState, useEffect } from 'react'
import AvailabilityDataTable from 'components/AvailabilityDataTable'
import useCurrentUser from 'hooks/useCurrentUser'
import { Select } from '@arnsbogroup/react-voicearchive'

const SupplierBookingsPage = ({ match }) => {

  const [bookings, setBookings] = useState([])
  const [supplier, setSupplier] = useState(null)
  const [selectedSupplierId, setSelectedSupplierId] = useState(null)
  const {isHeadOfAgency, agency} = useCurrentUser()

  useEffect(() => {
    fetch(`/rest/v2/${isHeadOfAgency ? 'agency' : 'supplier'}/${isHeadOfAgency ? agency?.uid : match.params.supplierId}?includeRelations=1`, { credentials: 'same-origin' }) 
      .then((response) => response.json())
      .then((response) => {
        setSupplier(isHeadOfAgency ? response.data : response)
        setSelectedSupplierId(isHeadOfAgency ? response.data.headSupplier.uid : response.uid)
      })
      .catch((error) => toastr.error(error))
  }, [])
  
  useEffect(() => {
    if (!selectedSupplierId) {
      return
    }

    fetch(`/rest/v2/supplier/${selectedSupplierId}/booking`, { credentials: 'same-origin' }) 
      .then((response) => response.json())
      .then((bookings) => 
        setBookings(bookings.sort((a, b) => (
          a.startDate > b.startDate ? 1 : -1
        )))
      )
      .catch((error) => toastr.error(error))
  }, [selectedSupplierId])

  const bookingAction = (action, bookingId, internalAvailabilities, message = '') => {
    const body = JSON.stringify({
      [action] : 1,
      message: message
    })

    fetch(`/rest/v2/supplier/${selectedSupplierId}/booking/${bookingId}`, { method: 'PUT', body, credentials: 'same-origin' })
      .then((response) => response.json())
      .then((json) => {
        setBookings(internalAvailabilities.map((event) => {
          if ('bookingDetails' in event && event.bookingDetails.uid == json.uid) {
            event.bookingDetails = json
            return event
          }else if (!event.uid || event.uid == json.uid) {
            return json
          } else {
            return event
          }
        }))
      })
      .catch((error) => toastr.error(error))
  }

  if (!supplier) {
    return null
  }

  return (
    <div className='mt-2 w-full'>
      {'members' in supplier && isHeadOfAgency &&
        <div className="m-2 w-3/12">
          <Select
            label="Members"
            description={`Members that belong to ${supplier.name}`}
            placeholder="Members"
            options={supplier.members.map((member) => {
                  return {
                    label: member.userid,
                    value: member.uid
                  }
                }
              
            )}
            onChange={(member) => setSelectedSupplierId(member.value) } 
            value={
              supplier.members
                .map((supplier) =>{ 
                  return {
                    label: supplier.userid,
                    value: supplier.uid
                  }
                })
                .find((member) => member.value == selectedSupplierId)
            }
          />
        </div>
      }
      <AvailabilityDataTable
        noDataMessage="No bookings currently available"
        bookingAction={(action, bookingId, internalAvailabilities, message) => bookingAction(action, bookingId, internalAvailabilities, message)}
        bookings={bookings}
        availabilities={[]}
      />
    </div>
  )
}

export default SupplierBookingsPage
